import axiosClient from "../../api/axiosClient";

export const allSchoolsFromServer = async () => {
  const response = await axiosClient.get("/schools");
  return response.data;
};